import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import triangleButton from '../assets/images/triangle.svg';
import musicBG from '../assets/images/bars1-and-notes.png';

export default class SongSelection extends Component {

    constructor() {
        super();

        this.state = {
            selectedIndex: 0,
            currentFactIndex: 0
        };
    }
// TODO fix logic for looping with song select
    changeSong(value) {
        if(this.state.selectedIndex === 0 && value === -1) {
            value = this.props.songs.length-1;
        } else if(this.state.selectedIndex === this.props.songs.length-1 && value === 1) {
            value = 0;
        } else {
            value = this.state.selectedIndex+value
        }

        this.setState({
            selectedIndex: value
        });
    }

    componentWillMount(){
      this.setState({
        selectedIndex: 0,
        currentFactIndex: 0
      });
    }

    render() {
        return (
            <div>
                <section className="song-selection-page-container">
                <img className="music-bg" src={musicBG}/>
                    <header>
                        <h1 className="page-title">Pick Your Performance</h1>
                    </header>

                    <section className="song-selection">
                        <button className="button-previous-song" onClick={() => {
                                    this.changeSong(-1);
                                }}
                        ><img src={triangleButton}/>
                        </button>
                        <ul className="song-info">
                            {
                                this.props.songs.map((song, index) => {
                                    return <li className={
                                        (index===this.state.selectedIndex)?"active":""

                                    }>
                                               <h2>{song.name}</h2>
                                               <h3>from <i>{song.production}</i> </h3>
                                               <p>{song.description}</p>
                                           </li>
                                })
                            }
                        </ul>
                        <button className="button-next-song" onClick={() => {
                            this.changeSong(1);
                        }}
                        ><img src={triangleButton}/></button>
                    </section>


                     <footer className="page-footer">

                     <Link className="button-primary button-exit" to="/">Exit </Link>

                     <Link className="button-primary" onClick={() => {
                              this.props.setSelectedSong(this.props.songs[this.state.selectedIndex]);
                          }}
                          to="/fact"
                    >Next</Link>
                </footer>

                </section>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SongSelection.js